import { ApiClient, BlackCrowPageIds } from '@storefronts/common-types'
import {
    IS_EDITOR_PREVIEW,
    IS_PREVIEW,
} from '../context/QueryParamContextProvider'
import { whenPixelScriptsReady } from '../components/pixels/pixelScriptScheduler'
import { to_snake_case } from '../utils/helpers'

export class BlackCrowLogger {
    private static initialized: boolean = false

    private static ProhibitedEvents: string[] = []

    public static initBlackCrow(client: ApiClient) {
        try {
            if (this.initialized) return
            if (IS_PREVIEW() || IS_EDITOR_PREVIEW()) return

            if (!window.blackcrow) {
                window.blackcrow = []
            }

            if (!client.shopifyShop) {
                console.log('No shopify shop found')
                return
            }

            const shopifyPrefix = client.shopifyShop.split('.')[0]
            const inject = () => {
                const script = document.createElement('script')
                script.src = `https://init.blackcrow.ai/js/core/${shopifyPrefix}.js`
                script.async = true
                document.getElementsByTagName('head')[0].appendChild(script)
            }

            this.initialized = true
            whenPixelScriptsReady(inject)
        } catch (err) {
            console.log(err)
        }
    }

    public static logPageViewEvent(pageName: BlackCrowPageIds) {
        if (!window.blackcrow) {
            window.blackcrow = []
        }
        window.blackcrow.push({
            trigger: 'set',
            data: {
                page_id: pageName,
            },
        })
        window.blackcrow.push({ trigger: 'refresh' })
    }

    public static logEvent(eventName: string, event: CustomEvent) {
        if (BlackCrowLogger.ProhibitedEvents.includes(eventName)) {
            return
        }

        const transformedEventName = to_snake_case(`storefront_${eventName}`)
        const data = event.detail

        if (data) {
            window.blackcrow?.push({
                trigger: 'partner_event',
                data: {
                    trigger: transformedEventName,
                    data: {
                        custom_dimensions: {
                            data,
                        },
                    },
                },
            })
        } else {
            window.blackcrow?.push({
                trigger: 'partner_event',
                data: {
                    trigger: transformedEventName,
                },
            })
        }
    }

    public static setUserProperties(props: Record<string, any>) {
        window.blackcrow?.push({
            trigger: 'partner_event',
            data: {
                trigger: 'storefront_vd_set_properties',
                data: {
                    custom_dimensions: {
                        props,
                    },
                },
            },
        })
    }

    public static triggerStorefrontsAnalyticsEvent(
        eventName: string,
        eventId: string,
        eventData: Record<string, any>,
        platformName: string,
    ) {
        window.blackcrow?.push({
            trigger: 'storefront_analytics',
            data: {
                platform_event_id: eventId,
                platform_event_name: eventName,
                platform_name: platformName,
                data: eventData,
            },
        })
    }
}
